import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";


const ConfirmDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Wait! Are you sure?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to assign a different question group to this
        event? This will require users to fill out a different profile for this
        event. If they have already filled out the old one, they will now need
        to fill out the new one...they might get grumpy!
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button autoFocus onClick={onConfirm}>
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;